import { collectAssetReferencesFromRenderData } from '../shared/assetReferences'
import type { RenderData } from '../assetTypes'

const escapeHtml = (value: string) =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')

const experimentsRenderer = (content: string) => `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <style>
      body {
        margin: 0;
        background-color: #ffffff;
        color: #111827;
        font-family: 'JetBrains Mono', Consolas, monospace;
        padding: 16px;
        white-space: pre;
        overflow: auto;
      }
    </style>
  </head>
  <body>${escapeHtml(content || '(empty)')}</body>
</html>`

export const collectAssetReferences = (content: string, renderData?: RenderData) =>
  collectAssetReferencesFromRenderData(content, renderData)

export default experimentsRenderer
